import React from "react";
import { useLocation } from "react-router-dom";

import ModifiedOrderSummaryComponent from "components/ModifiedOrderSummary/ModifiedOrderSummary";

const ModifiedOrderSummary = () => {
  const proposedOrder = useLocation().state?.proposedOrder;
  return (
    <div>
      <ModifiedOrderSummaryComponent proposedOrder={proposedOrder} />
    </div>
  );
};

export default ModifiedOrderSummary;
